import { gql } from '@apollo/client'

import { SIMPLE_ENTITY_FRAGMENT } from '../fragments'

const LANGUAGE_QUERY = gql`
  query languages {
    languages {
      ...SimpleEntityFragment
    }
  }
  ${SIMPLE_ENTITY_FRAGMENT}
`

export default LANGUAGE_QUERY
